import { Fragment } from 'react';
import { obtenerEstiloPresupuesto } from '../Helper';
import PropTypes from 'prop-types';

const ControlPresupuesto = ({ presupuesto, restante }) => {
  return (
    <Fragment>
      <div className='alert alert-primary'>Presupuesto: $ {presupuesto}</div>

      <div className={obtenerEstiloPresupuesto(presupuesto, restante)}>
        Restante: $ {restante}
      </div>
    </Fragment>
  );
};

ControlPresupuesto.propTypes = {
  presupuesto: PropTypes.number.isRequired,
  restante: PropTypes.number.isRequired,
};

export default ControlPresupuesto;
